import "@cyntler/react-doc-viewer/dist/index.css";
import { BackAppBar } from "@/components/ui";
import { HeicRenderer } from "@/libraries/cyntler";
import type { Bulletin } from "@/types";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import type { IConfig, IDocument } from "@cyntler/react-doc-viewer";
import isEqual from "fast-deep-equal";
import { memo, useMemo } from "react";

interface DrawerViewBulletinProps {
	bulletin?: Bulletin | null;
	onClickClose: () => void;
}

const PluginRenderers = DocViewerRenderers.concat([HeicRenderer]);

const DocConfig: IConfig = {
	header: {
		disableHeader: true,
		disableFileName: true,
	},
};

const DrawerViewBulletin = (props: DrawerViewBulletinProps) => {
	const { bulletin, onClickClose } = props;
	const fileUrl = bulletin?.link ?? bulletin?.image_url;

	const fileDocs = useMemo(
		() =>
			[
				{
					uri: fileUrl,
				},
			] as IDocument[],
		[fileUrl],
	);

	if (!bulletin || !fileUrl) return null;
	return (
		<div className="relative h-dvh w-screen bg-white flex flex-col overflow-hidden">
			<div className="relative wrapper">
				<BackAppBar onBack={onClickClose} title={bulletin.title ?? "-"} />
			</div>
			<div className="flex-1 relative wrapper bg-gray-light">
				<div className="container h-full">
					<DocViewer
						config={DocConfig}
						documents={fileDocs}
						initialActiveDocument={fileDocs[0]}
						pluginRenderers={PluginRenderers}
						className="!bg-gray-light justify-center items-center [&_#image-renderer]:!bg-gray-light [&_#no-renderer]:flex [&_#no-renderer]:flex-col [&_#no-renderer]:justify-center [&_#no-renderer]:items-center [&_#no-renderer]:gap-4"
					/>
				</div>
			</div>
		</div>
	);
};

export default memo(DrawerViewBulletin, (prevProps, nextProps) =>
	isEqual(prevProps.bulletin, nextProps.bulletin),
);
